import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Vehicle = () => {
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/vehicles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setVehicles(res.data);
      } catch (err) {
        console.error('Failed to fetch vehicles:', err);
      }
    };

    fetchVehicles();
  }, []);
  
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this vehicle?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/vehicles/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setVehicles(prev => prev.filter(v => v._id !== id));
    } catch (err) {
      console.error('Delete error:', err);
      alert('Failed to delete vehicle');
    }
  };


  return (
    <div className="container mt-4">
      <h2 className="mb-4">Vehicle List</h2>
      <a href='/create-vehicle' className='btn btn-primary text-start mb-2'>+ New Vehicle</a>
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Plate Number</th>
              <th>Office</th>
              <th>Type</th>
              <th>Status</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {vehicles.map((vehicle, index) => (
              <tr key={vehicle._id}>
                <td>{index + 1}</td>
                <td>{vehicle.name}</td>
                <td>{vehicle.plateNumber}</td>
                <td>{vehicle.office}</td>
                <td>{vehicle.type}</td>
                <td>{vehicle.status}</td>
                <td>{vehicle.remarks}</td>
                <td>
                  <Link to={`/vehicles/${vehicle._id}/edit`} className="btn btn-sm btn-warning btn-outline-secondary me-2">
                    Edit
                  </Link>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(vehicle._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Vehicle;
